import { ListInvoiceApiRequest } from "@/data/payload/api/PrintReceiptRequest";
export class PrintReceiptEndpoint {
  create() {
    return "/hydra/v1/invoice";
  }
  getDetailInvoice(id: number) {
    return `/hydra/v1/invoice/${id}`;
  }
  getBookingHistoryDetail() {
    return "/hydra/v1/invoice/booking-history";
  }

  sendInvoice(id: number) {
    return `/hydra/v1/invoice/${id}/send`;
  }

  getListInvoices(params: ListInvoiceApiRequest) {
    return `/hydra/v1/invoice?${params.toQueryString()}`;
  }

  settlementInvoice(id: number) {
    return `/hydra/v1/invoice/${id}/settlement`;
  }

  paymentDetailInvoice(id: number) {
    return `/hydra/v1/invoice/payment/${id}`;
  }

  addDraft() {
    return `/hydra/v1/invoice/draft/add`;
  }

  getPreview() {
    return `/hydra/v1/invoice/draft/items`;
  }

  getInvoiceForUpdate(id: number) {
    return `/hydra/v1/invoice/${id}/for-update`;
  }

  draftPreviewForUpdate(id: number) {
    return `/hydra/v1/invoice/${id}/draft/preview`;
  }

  updateInvoice(id: number) {
    return `/hydra/v1/invoice/${id}`;
  }

  activity(id: number) {
    return `/hydra/v1/invoice/${id}/activity`;
  }

  clearDraftItems() {
    return "/hydra/v1/invoice/draft/items";
  }
}
